export const SUBJECTS = 'subjects'
export const CLASSES = 'classes'
export const CATEGORIES = 'categories'
export const CLUBS = 'clubs'
export const STANDARDS = 'standards'
